export function StepEndIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='20' height='16' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M0 0H14C17.3137 0 20 2.68629 20 6V10C20 13.3137 17.3137 16 14 16H0L8 8L0 0Z'
        fill='currentColor'
      />
    </svg>
  )
}
